import { useCallback } from 'react';
import ReactGA from 'react-ga4';
import { GA_ENABLED, GA_TRACKING_ID } from '../../config';
import { pathToTitle } from '../../utils/shared.utils';

export const useGA = () => {
  const initialize = useCallback(() => {
    if (GA_ENABLED === 'true' && !ReactGA.isInitialized) {
      ReactGA.initialize(GA_TRACKING_ID);
    }
  }, []);

  const setUser = useCallback((userId: number | undefined) => {
    if (ReactGA.isInitialized && userId) {
      ReactGA.set({
        userId: userId,
      });
    }
  }, []);

  const trackPageView = useCallback(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
      title: pathToTitle(window.location.pathname),
    });
  }, []);

  return { initialize, setUser, trackPageView };
};
